import React from "react";
import { Rect, Path, Circle, G, Line } from "@react-pdf/renderer";
import tinycolor from "tinycolor2";

export default function PdfNCAACourt(props) {
  let color = tinycolor(props.lineColor);
  let alpha = color.getAlpha();
  let hex = color.toHexString();

  return (
    <>
      {/*SIDELINE*/}
      <Rect
        strokeWidth={props.sidelines === 0 ? 0.4 : 0.2}
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        x="-25"
        y="0"
        width="50"
        height="94"
      />
      {/*BACKBOARD*/}
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -3 4 L 3 4"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -3 90 L 3 90"
      />
      {/*BASKET*/}
      <Circle
        r="0.75"
        cx="0"
        cy="5.25"
        fill="none"
        strokeWidth="0.2"
        stroke={hex}
        strokeOpacity={alpha}
      />
      <Circle
        r="0.75"
        cx="0"
        cy="88.75"
        fill="none"
        strokeWidth="0.2"
        stroke={hex}
        strokeOpacity={alpha}
      />
      {/*PAINTED AREA*/}
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -6 94 L -6 75 L 6 75 L 6 94"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -6 0 L -6 19 L 6 19 L 6 0"
      />
      {/*Circle Free Throw*/}
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -6 19 A 6 6 0 0 0 6 19"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M 6 75 A 6 6 0 0 0 -6 75"
      />
      {/*Three Point Line*/}
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -21.65 0 L -21.65 9.95"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M 21.65 0 L 21.65 9.95"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -21.65 94 L -21.65 84.05"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M 21.65 94 L 21.65 84.05"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M -21.65 9.97974358272 A 22.15 22.15 0 0 0 21.65 9.97974358272"
      />
      <Path
        strokeWidth="0.2"
        fill="none"
        stroke={hex}
        strokeOpacity={alpha}
        d="M 21.65 84.0202564173 A 22 22 0 0 0 -21.65 84.0202564173"
      />

      <Circle
        r="6"
        cx="0"
        cy="47"
        fill="none"
        strokeWidth="0.2"
        stroke={hex}
        strokeOpacity={alpha}
      />
      {hex !== "#fff" && (
        <Path
          strokeWidth={props.sidelines === 0 ? 0.4 : 0.2}
          fill="none"
          stroke={hex}
          strokeOpacity={alpha}
          d="M -25 47 L 25 47"
        />
      )}

      {props.showChargingCircle && (
        <Path
          strokeWidth="0.2"
          fill="none"
          stroke={hex}
          strokeOpacity={alpha}
          d="M  -4 5.25  A 4 4 0 0 0 4 5.25"
        />
      )}

      {props.showKeyHashMarks && (
        <G>
          <Line
            y1="18"
            x1="-6"
            y2="18"
            x2="-6.5"
            stroke={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />
          <Line
            y1="15"
            x1="-6"
            y2="15"
            x2="-6.5"
            stroke={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />
          <Line
            y1="12"
            x1="-6"
            y2="12"
            x2="-6.5"
            stroke={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />
          <Rect
            y="8"
            x="-6.5"
            height={1}
            width={0.5}
            fill={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />

          <Line
            y1="18"
            x1="6"
            y2="18"
            x2="6.5"
            stroke={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />
          <Line
            y1="15"
            x1="6"
            y2="15"
            x2="6.5"
            stroke={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />
          <Line
            y1="12"
            x1="6"
            y2="12"
            x2="6.5"
            stroke={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />
          <Rect
            y="8"
            x="6"
            width={0.5}
            height={1}
            fill={hex}
            strokeOpacity={alpha}
            strokeWidth="0.2"
          />
        </G>
      )}
    </>
  );
}
